import { createRoot } from "react-dom/client";

import UserApp from "./UserApp";

// Opt-in to Webpack hot module replacement
if (module.hot) module.hot.accept();

const root = createRoot(document.getElementById("root"));
root.render(<UserApp />);
